/*
 * @Author: c.k
 * @Date: 2023-03-02 19:19:42
 * @LastEditors: c.k
 * @LastEditTime: 2023-03-06 15:07:06
 * @Descripttion:
 */
import Vue from 'vue'
import * as RongIMLib from '@rongcloud/imlib-next'
// 全局常量
export default ({ $axios, app, store }, inject) => {
    //注入到全局nuxt示例中
    inject('RongIMLib', RongIMLib)
}

Vue.use(RongIMLib)
